import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1b9f4cef"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "CostFiles"
}
const _hoisted_2 = { class: "CostFiles__title" }
const _hoisted_3 = { class: "mt-5" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Кто загрузил:", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "CostFiles__subtitle" }, "Стоимость платной парковки", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "CostFiles__subtitle" }, "Стоимость платного проезда", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_uploaded_file = _resolveComponent("uploaded-file")!

  return (_ctx.isParkingFiles || _ctx.isRoadFiles)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "CostFiles__header",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleCostFiles && _ctx.toggleCostFiles(...args)))
        }, [
          _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.title), 1),
          _createElementVNode("i", {
            class: _normalizeClass(_ctx.getClass)
          }, null, 2)
        ]),
        _createVNode(_Transition, null, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("div", null, [
              _createElementVNode("p", _hoisted_3, [
                _hoisted_4,
                _createTextVNode(" " + _toDisplayString(_ctx.userEmail), 1)
              ]),
              _createVNode(_component_uploaded_file, {
                "is-visible": _ctx.isParkingFiles,
                files: _ctx.state.checks_parking,
                title: "Фото о платной парковке",
                class: "my-5",
                "no-delete": ""
              }, null, 8, ["is-visible", "files"]),
              _hoisted_5,
              _createElementVNode("p", null, _toDisplayString(_ctx.state.cost_parking || 0) + " ₸", 1),
              _createVNode(_component_uploaded_file, {
                "is-visible": _ctx.isRoadFiles,
                files: _ctx.state.checks_road,
                title: "Фото о платном проезде",
                class: "my-5",
                "no-delete": ""
              }, null, 8, ["is-visible", "files"]),
              _hoisted_6,
              _createElementVNode("p", null, _toDisplayString(_ctx.state.cost_road || 0) + " ₸", 1)
            ], 512), [
              [_vShow, _ctx.state.is_visible]
            ])
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}